import { Button, Combobox } from "@aidkitorg/component-library";
import { Survey } from "@aidkitorg/types/lib/survey";
import { useMemo, useState } from "react";
import { InfoDict } from "./Questions/Props";

export function TargetFieldExplorer(props: {
  survey: Survey,
  mockInfo: InfoDict,
  setMockInfo: (value: React.SetStateAction<InfoDict>) => void
}) {
  const [searchTerm, setSearchTerm] = useState('');
  const sorted = useMemo(() => {
    return Object.keys(props.mockInfo || {}).sort();
  }, [props.mockInfo]);

  const filtered = useMemo(() => {
    if (!searchTerm) return sorted;
    return sorted.filter((item) => item.toLowerCase().includes(searchTerm.toLowerCase()));
  }, [sorted, searchTerm]);

  return <div className='mx-3'>
    <h2>Target Fields <Button onClick={() => { props.setMockInfo({}) }} color="blue">Clear Fields</Button></h2>
    <Combobox
      label={'Search for a field'}
      options={sorted.map(k => { return { value: k, label: k } })}
      multiple={false}
      onChange={(newValue) => setSearchTerm(newValue.value)}
    />
    {filtered.length > 0
      ? <table className='w-full'>
        <thead>
          <tr>
            <th>Field Name</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          {filtered.map((k) =>
            <tr key={k}>
              <td className='border border-gray-300 px-2'>{k}</td>
              <td className='border border-gray-300 px-2'>{props.mockInfo[k] ? props.mockInfo[k] : ''}</td>
            </tr>
          )}
        </tbody>
      </table>
      : <p>No fields entered yet</p>}
  </div>
}